import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import router from "./router";
import "./assets/iconfont/iconfont.css";
// import { NumberKeyboard } from "vant";
// 需npm install --save-dev less-loader less 再引入
import "./assets/style/global.less";

// 按需加载element
import ElementPlus from '@/plugin/element'
import 'element-plus/theme-chalk/index.css'




const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(ElementPlus);
// app.use(NumberKeyboard);
import { setupRouterGuards } from './router/permission'; // 引入鉴权函数
// 在这里调用鉴权函数，确保Pinia实例已创建, 因为鉴权函数中会用到pinia实例
setupRouterGuards(router);
//浏览器类型判断
import { useWebTypeStore } from './store/webtype';
const webTypeStore = useWebTypeStore();
webTypeStore.setWebType();
// console.log(webTypeStore.isWX, webTypeStore.isMobile);



// 引入全局组件
app.mount('#app');




// createApp(App).use(createPinia()).use(router).use(ElementPlus).mount("#app");
